<template>
  <card-info-component
    :title="$t('pages.dashboard.widgets.vacation_forecast')"
    :value="holidaysTotal"
    :is-loading="!userData"
    icon="fa-calendar-check"
    tone="info"
  ></card-info-component>
</template>

<script>
import { CardInfoComponent } from "@/pages/components";
import { mapGetters } from "vuex";

export default {
  components: {
    CardInfoComponent,
  },
  computed: {
    ...mapGetters("auth", ["holidaysTotal", "userData"]),
  },
};
</script>

<style scoped></style>
